import React from "react";

export default function PendapatanWajibBayar({
  tahun,
  setTahun,
  pendapatanwajibbayar,
}) {
  let pendapatanKotorWajibBayar = Object.entries(pendapatanwajibbayar);

  const thisYearTahunBuku = new Date().getFullYear() - 1;

  const increaseTahun = () => {
    if (tahun + 1 <= thisYearTahunBuku) {
      setTahun((inputTahun) => inputTahun + 1);
    }
  };

  const decreaseTahun = () => {
    if (tahun > 2018) {
      setTahun((inputTahun) => inputTahun - 1);
    }
  };
  return (
    <>
      <div className="w-full pb-10 rounded-lg border border-neutral-300 bg-gray-light">
        <div className="flex flex-warp px-4 py-4">
          <div className="basis-auto self-center">
            <h4 className="text-base font-semibold text-gray-dark mr-3">
              Tahun Buku :{" "}
            </h4>
          </div>
          <div className="basis-auto">
            <div className="flex flex-row">
              <button
                onClick={decreaseTahun}
                type="button"
                className="px-2 md:px-3 py-1 md:py-2 mr-2 last:mr-0 bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300"
              >
                <div className="flex flex-row align-middle">
                  <svg
                    className="w-4 md:w-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
              </button>

              <p className="mr-2 last:mr-0 p-1 md:p-2 text-center text-sm md:text-base bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300">
                {tahun}
              </p>

              <button
                onClick={increaseTahun}
                type="button"
                className="px-2 md:px-3 py-1 md:py-2 mr-2 last:mr-0 bg-primary-second text-white rounded-lg border border-neutral-300 hover:bg-primary-main duration-300"
              >
                <div className="flex flex-row align-middle">
                  <svg
                    className="w-4 md:w-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div className="flex flex-warp bg-white border-t border-b border-neutral-300">
          <div className="overflow-x-scroll md:overflow-x-hidden w-full">
            <table className="table-auto min-w-full">
              <tbody>
                {pendapatanKotorWajibBayar.length !== 0 ? (
                  pendapatanKotorWajibBayar.map(([key, value], i) => {
                    return (
                      <tr className="odd:bg-primary-fifth/40 even:bg-white border-b border-b-neutral-300 last:border-b-0">
                        <td className="p-2 md:p-4 font-semibold">
                          <div className="flex rounded-full bg-white border border-gray-dark w-8 h-8 md:w-10 md:h-10 justify-center">
                            <p className="pt-1 md:pt-2 text-sm md:text-base">
                              {i + 1}
                            </p>
                          </div>
                        </td>
                        <td className="p-2 md:p-4">
                          <p className="text-sm md:text-base font-medium">
                            {value.nama_perusahaan}
                          </p>
                          <p className="text-xs md:text-sm text-gray-dark font-medium">
                            Wajib Bayar
                          </p>
                        </td>
                        <td className="p-2 md:p-4">
                          <p className="text-sm md:text-base font-medium">
                            {Number(
                              value.nilai_pendapatan_kotor
                            ).toLocaleString()}
                          </p>
                          <p className="text-xs md:text-sm text-gray-dark font-medium">
                            Pendapatan Kotor
                          </p>
                        </td>
                        <td className="p-2 md:p-4">
                          <p className="text-sm md:text-base font-medium">
                            {Number(
                              value.nilai_potensi_pendapatan
                            ).toLocaleString()}
                          </p>
                          <p className="text-xs md:text-sm text-gray-dark font-medium">
                            Potensi Pendapatan
                          </p>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="odd:bg-primary-fifth/40 even:bg-white border-b border-b-neutral-300 last:border-b-0">
                    <td className="p-2 md:p-4">
                      <p className="text-sm md:text-base text-gray-dark text-center font-medium">
                        Data Pendapatan Wajib Bayar Terbesar Tidak Ditemukan
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
